import React, { useState, useEffect } from "react";
import axios from "axios";


const EditAddress = ({ existingData, onBack, refreshAddresses }) => {
  const [formData, setFormData] = useState(existingData);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const user_auto_id = sessionStorage.getItem("accessToken");
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");


  useEffect(() => {
  const storedStyle = sessionStorage.getItem("UIStyle");
  if (storedStyle) {
    const parsedStyle = JSON.parse(storedStyle);
    setWebFont(parsedStyle.web_font);
    setThemeColor(parsedStyle.web_theme_colour)
  }
}, []);
function lightenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) + 255 * percent;
  let g = ((num >> 8) & 0x00ff) + 255 * percent;
  let b = (num & 0x0000ff) + 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}

function darkenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) - 255 * percent;
  let g = ((num >> 8) & 0x00ff) - 255 * percent;
  let b = (num & 0x0000ff) - 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/edit_user_address`,
        {
          ...formData,
          admin_auto_id,
          user_auto_id,
          address_auto_id: formData._id, // assuming Mongo _id is used
        }
      );

      if (res.data.status === "1") {
        setMessage("Address updated successfully!");
        setMessageType("success");
        refreshAddresses?.();
        setTimeout(() => {
          setMessage("");
          onBack();
        }, 2000);
      } else {
        setMessage(res.data.message || "Failed to update address");
        setMessageType("error");
        setTimeout(() => setMessage(""), 2000);
      }
    } catch (error) {
      console.error("Error updating address:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`p-6 ${webFont}`}>
      <div className="flex items-center justify-between px-6 py-2 mb-6 bg-white border border-gray-200 rounded-lg shadow-sm">
        <h2 className="text-xl font-bold">
          Edit Address
        </h2>
      </div>
      <form
  onSubmit={handleSubmit}
  className="grid grid-cols-1 gap-4 p-4 md:grid-cols-2 md:p-6"
>
  {[
    ["Name", "name"],
    ["Mobile No", "mobile_no"],
    ["Area", "area"],
    ["City", "city"],
    ["State", "state"],
    ["Country", "country"],
    ["Pincode", "pincode"],
    ["Address Details", "address_details"],
  ].map(([label, name]) => (
    <div key={name} className="w-full">
      <label className="block text-sm font-medium mb-1">{label}</label>

      <input
        name={name}
        value={formData[name]}
        onChange={handleChange}
        required
        className="w-full px-3 py-2 border rounded text-sm md:text-base"
      />
    </div>
  ))}

  {/* Address Type — full width only on desktop */}
  <div className="md:col-span-2 w-full">
    <label className="block mb-1 text-sm font-medium">Address Type</label>

    <div className="flex gap-4">
      {["Home", "Work", "Other"].map((type) => (
        <label key={type} className="flex items-center gap-2">
          <input
            type="radio"
            name="address_type"
            value={type}
            checked={formData.address_type === type}
            onChange={handleChange}
          />
          {type}
        </label>
      ))}
    </div>
  </div>

  {/* Buttons — full width on desktop only */}
  <div className="md:col-span-2 mt-4 relative w-full">
    <div className="flex justify-between">
      <button
        type="button"
        onClick={onBack}
        className="px-4 py-2 border border-gray-400"
      >
        Cancel
      </button>

      {message && (
        <span
          className={`absolute top-[-1.5rem] right-0 text-sm ${
            messageType === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {message}
        </span>
      )}

      <button
        type="submit"
        className="px-4 py-2 text-white"
        disabled={isSubmitting}
        style={{ backgroundColor: themeColor }}
      >
        {isSubmitting ? "Updating..." : "Update Address"}
      </button>
    </div>
  </div>
</form>

    </div>
  );
};

export default EditAddress;
